import React, { createContext, useEffect, useState } from "react";
import logger from "./Logger";
import { IS_TEST } from "../consts";

// Create the context
export const LocationContext = createContext();

// Create the provider component
export const LocationProvider = ({ children }) => {
  const [locationCommuteResultMap, setLocationCommuteResult] = useState(new Map());
  const [locationInfo, setLocationInfo] = useState([]);
  /// TODO - remove as this is for testing
  const [locationData, setLocationData] = useState(
    IS_TEST
      ? [
          {
            Address: "11704 Tanglebriar Trail, Austin, TX 78750, USA",
            "Showing Contact Phone": "(512)373-2353",
            "Showing Requirements": "Agent or Owner Present, Call Listing Agent, Text Listing Agent",
            "Street Number": "11704",
            "Street Name": "Tanglebriar",
            "Street Type": "Trail",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-001",
          },
          {
            Address: "9707  Anderson Mill Rd  #3110503 Weller Dr, Austin, TX 78750, USA",
            "Showing Contact Phone": "5126298292",
            "Showing Requirements": "Call Listing Agent, See Showing Instructions, Text Listing Agent",
            "Street Number": "9707",
            "Street Name": "Anderson Mill",
            "Street Type": "Road",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-002",
          },
          {
            Address: "10518 Glass Mountain Trail, Austin, TX 78750, USA",
            "Showing Contact Phone": "",
            "Showing Requirements": "Go",
            "Street Number": "10518",
            "Street Name": "Glass Mountain",
            "Street Type": "Trail",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-003",
          },
          {
            Address: "13301 N Hwy 183, Austin, TX 78750, USA",
            "Showing Contact Phone": "512-552-2198",
            "Showing Requirements": "Call First - Go, Text Listing Agent",
            "Street Number": "13301",
            "Street Name": "N Hwy 183",
            "Street Type": "Highway",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-004",
          },
          {
            Address: "11800  Aloe Vera Trl",
            "Showing Contact Phone": "737-280-2568",
            "Showing Requirements": "Appointment Only, Go, Lockbox, Showing Service, Sign on Property",
            "Street Number": "11800",
            "Street Name": "Aloe Vera",
            "Street Type": "Trail",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-005",
          },
          {
            Address: "12002  Hardwood Trl",
            "Showing Contact Phone": "",
            "Showing Requirements": "Go",
            "Street Number": "12002",
            "Street Name": "Hardwood",
            "Street Type": "Trail",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-006",
          },
          {
            Address: "6307  Lakewood Holw",
            "Showing Contact Phone": "5127550061",
            "Showing Requirements": "Call Listing Agent, Lockbox, Sign on Property, Text Listing Agent",
            "Street Number": "6307",
            "Street Name": "Lakewood",
            "Street Type": "Hollow",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-007",
          },
          {
            Address: "11506  Fence Post Trl",
            "Showing Contact Phone": "512 962-0723",
            "Showing Requirements": "Go, Lockbox, See Showing Instructions, Sign on Property, Text Listing Agent",
            "Street Number": "11506",
            "Street Name": "Fence Post",
            "Street Type": "Trail",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-008",
          },
          {
            Address: "10500 Nicolet Way, Austin, TX 78717, USA",
            "Showing Contact Phone": "512-657-0453",
            "Showing Requirements": "Go, Text Listing Agent",
            "Street Number": "10500",
            "Street Name": "Nicolet",
            "Street Type": "Way",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78717",
            "Listing ID": "LIST-009",
          },
          {
            Address: "11508  SANDY LOAM Trl",
            "Showing Contact Phone": "",
            "Showing Requirements": "Go, Lockbox",
            "Street Number": "11508",
            "Street Name": "Sandy Loam",
            "Street Type": "Trail",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-010",
          },
          {
            Address: "10503 Weller Dr, Austin, TX 78750, USA",
            "Showing Contact Phone": "",
            "Showing Requirements": "Go, Lockbox",
            "Street Number": "10503",
            "Street Name": "Weller",
            "Street Type": "Drive",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-011",
          },
          {
            Address: "7300  Colina Vista Vis  #B",
            "Showing Contact Phone": "2103966181",
            "Showing Requirements": "Call Listing Agent, Showing Service, Text Listing Agent",
            "Street Number": "7300",
            "Street Name": "Colina Vista",
            "Street Type": "Vista",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-012",
          },
          {
            Address: "12306  Double Tree Ln",
            "Showing Contact Phone": "",
            "Showing Requirements": "Go, Sign on Property",
            "Street Number": "12306",
            "Street Name": "Double Tree",
            "Street Type": "Lane",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-013",
          },
          {
            Address: "9404  Solana Vista Loop  #A",
            "Showing Contact Phone": "5129838130",
            "Showing Requirements": "Lockbox, Showing Service",
            "Street Number": "9404",
            "Street Name": "Solana Vista",
            "Street Type": "Loop",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-014",
          },
          {
            Address: "7309  Colina Vista Loop  #A",
            "Showing Contact Phone": "",
            "Showing Requirements": "24 Hour Notice, Lockbox, See Showing Instructions, Showing Service",
            "Street Number": "7309",
            "Street Name": "Colina Vista",
            "Street Type": "Loop",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-015",
          },
          {
            Address: "7302  Jester Blvd",
            "Showing Contact Phone": "5127865192",
            "Showing Requirements": "Go",
            "Street Number": "7302",
            "Street Name": "Jester",
            "Street Type": "Boulevard",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-016",
          },
          {
            Address: "9215  Ashton Rdg",
            "Showing Contact Phone": "855-915-0167",
            "Showing Requirements": "Appointment Only, Lockbox, See Showing Instructions, Showing Service",
            "Street Number": "9215",
            "Street Name": "Ashton",
            "Street Type": "Ridge",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-017",
          },
          {
            Address: "8418  Fathom Cir  #503",
            "Showing Contact Phone": "5124155616",
            "Showing Requirements": "Go, Lockbox, Text Listing Agent",
            "Street Number": "8418",
            "Street Name": "Fathom",
            "Street Type": "Circle",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-018",
          },
          {
            Address: "9228  Limoncillo Dr",
            "Showing Contact Phone": "512-699-4953",
            "Showing Requirements": "Call First - Go",
            "Street Number": "9228",
            "Street Name": "Limoncillo",
            "Street Type": "Drive",
            City: "Austin",
            "State Or Province": "TX",
            "Postal Code": "78750",
            "Listing ID": "LIST-019",
          },
        ]
      : []
  );

  const setLocationCommuteResultMap = (map) => {
    setLocationCommuteResult(map);
  };
  // TODO change the object to include the commute result and style as a property
  const getLocationCommuteResultValue = (key) => {
    return locationCommuteResultMap.get(key);
  };

  const getLocationAddresses = (item) => {
    const address = `${item["Street Number"]} ${item["Street Name"]} ${item["Street Type"]} ${item.City} ${item["State Or Province"]} ${item["Postal Code"]} `;
    return address;
  };

  const getLocationListingId = (item) => {
    logger.info("This is the listing Id - ", item["Listing ID"]);
    return item["Listing ID"];
  };

  useEffect(() => {
    logger.debug("this is locationData - ", locationData);
  }, [locationData]);

  return (
    <LocationContext.Provider
      value={{
        locationCommuteResultMap,
        setLocationCommuteResultValue: setLocationCommuteResultMap,
        getLocationCommuteResultValue,
        locationInfo,
        setLocationInfo,
        locationData,
        setLocationData,
        getLocationAddresses,
        getLocationListingId,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};
